export const COLUMN_COLORS = [
  "#e0e7ff",
  "#d1fae5",
  "#fef3c7",
  "#dbeafe",
  "#fce7f3",
  "#ede9fe",
  "#ffedd5",
];
